import { render, staticRenderFns } from "./form16.vue?vue&type=template&id=25c7bbe8&scoped=true&"
import script from "./form16.vue?vue&type=script&lang=js&"
export * from "./form16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7bbe8",
  null
  
)

export default component.exports